module.exports = __webpack_public_path__ + "img/paso-1.07b78f7c.png";